const symbolSubsetSelector = (symbols, numberToSelect, shuffler) => {
  const shuffledSymbols = shuffler(symbols);
  return shuffledSymbols.slice(0, numberToSelect);
};

export default symbolSubsetSelector;
